
export default {
  formatTimeToMinutes,
  secondsToHms,
  handleTimeAdd,
  secondsToHHMM,
  secondsToMMSS,
  formatTime,
  calculatePricePerDurations,
  hasEmptyName,
  calculateFinalPrice,
  updateOnlineStatus,
  updateOnlineStatusForUserSearch
}


function formatTimeToMinutes(timeString) {
  var timeParts = timeString?.split(":");

  var hours = parseInt(timeParts[0], 10);
  var minutes = parseInt(timeParts[1], 10);
  var seconds = parseInt(timeParts[2], 10);

  var totalMinutes = hours * 60 + minutes + seconds / 60;

  return Number(totalMinutes);
}

function secondsToHms(d) {
  d = Number(d);
  var h = Math.floor(d / 3600);
  var m = Math.floor(d % 3600 / 60);
  var s = Math.floor(d % 3600 % 60);

  var hDisplay = h > 0 ? h + (h == 1 ? " hour " : " hours, ") : "";
  var mDisplay = m > 0 ? m + (m == 1 ? " minute " : " minutes, ") : "";
  var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
  return hDisplay + mDisplay + sDisplay;
}

function handleTimeAdd(time1, time2) {
  // Split the time strings into hours, minutes, and seconds
  const [hours1, minutes1, seconds1] = time1.split(':').map(Number);
  const [hours2, minutes2, seconds2] = time2.split(':').map(Number);

  // Convert the time durations to seconds
  const totalSeconds1 = hours1 * 3600 + minutes1 * 60 + seconds1;
  const totalSeconds2 = hours2 * 3600 + minutes2 * 60 + seconds2;

  // Add the time durations
  const totalSecondsResult = totalSeconds1 + totalSeconds2;

  // Convert the total seconds back to hours, minutes, and seconds
  const resultHours = Math.floor(totalSecondsResult / 3600);
  const resultMinutes = Math.floor((totalSecondsResult % 3600) / 60);
  const resultSeconds = totalSecondsResult % 60;

  // Format the result
  const result = `${resultHours.toString().padStart(2, '0')}:${resultMinutes.toString().padStart(2, '0')}:${resultSeconds.toString().padStart(2, '0')}`;

  return result

}

function secondsToHHMM(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  // Ensure that hours and minutes are formatted as two digits with leading zeros
  const formattedHours = hours.toString().padStart(2, '0');
  const formattedMinutes = minutes.toString().padStart(2, '0');

  return `${formattedHours}:${formattedMinutes}`;
}

function secondsToMMSS(seconds) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  // Ensure that minutes and seconds are formatted as two digits with leading zeros
  const formattedMinutes = minutes.toString().padStart(2, '0');
  const formattedSeconds = remainingSeconds.toString().padStart(2, '0');

  return `${formattedMinutes}:${formattedSeconds}`;
}

function calculatePricePerDurations (perMinutePrice , discount) {
  const durations = [1, 5, 10, 15];
  const priceObjects = durations.map(duration =>({
      discount: discount,
      time: duration,
      price: (duration * perMinutePrice),
      final_price: Number(duration * perMinutePrice) * Number(duration === 1 ? 1 : (1 - discount / 100))
    })
  )
  return priceObjects;
}


function formatTime(minutes) {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  const formattedHours = hours.toString().padStart(2, '0');
  const formattedMinutes = remainingMinutes.toString().padStart(2, '0');

  return `${formattedHours}:${formattedMinutes}:00`;
}

function hasEmptyName(arrayOfObjects) {
  for (let i = 0; i < arrayOfObjects.length; i++) {
    if (!arrayOfObjects[i].name) {
      return { hasEmptyName: true, objectWithEmptyName: arrayOfObjects[i] };
    }
  }
  return { hasEmptyName: false, objectWithEmptyName: null };
};

function calculateFinalPrice(price, duration, discount) {
  if (discount === 100) {
    return "00.00"
  } else if (discount < 1 || discount > 100) {
    return price
  }
  return price * (duration === 1 ? 1 : 1 - Number(discount / 100))
}

function updateOnlineStatus(lastSeen, onlineStatus) {
  const currentTime = new Date();
  const lastSeenTime = new Date(lastSeen);
  const timeDifference = currentTime.getTime() - lastSeenTime.getTime();
  const timeThreshold = 5 * 60 * 1000;
  if (timeDifference <= timeThreshold && onlineStatus !== 'offline') {
    return true;
  } else {
    return false;
  }
}

function updateOnlineStatusForUserSearch(lastSeen, onlineStatus) {
  if (!lastSeen || onlineStatus === 'offline') return false;

  const currentTime = new Date();
  const lastSeenTime = new Date(lastSeen.replace(' ', 'T') + '.000Z');

  if (isNaN(lastSeenTime.getTime())) {
    console.warn("Invalid date format for lastSeen:", lastSeen);
    return false;
  }

  const timeDifference = currentTime - lastSeenTime;
  const timeThreshold = 5 * 60 * 1000;

  return timeDifference <= timeThreshold;
}
